$(function () {
  $("a[href^='http']").filter(function () {
    return (
      this.hostname !== location.hostname &&
      !this.href.includes('/account')
    );
  }).attr("target", "_blank");
});

$(function(){
   // #で始まるアンカーをクリックした場合に処理
  $(document).on('click', 'a[href^="#"]', function(e) {
    if ($(this).hasClass('noSmooth')) return;
    e.preventDefault();
    var headerH = $('header').outerHeight() || 0;
    var speed = 1000;
    var href = $(this).attr('href');
    var target = (href === '#' || href === '')
    ? $('html')
    : $(href);
    if (!target.length) return false;
    var position;
    if ($(window).width() > 700) {
      position = target.offset().top;
    } else {
      position = target.offset().top - headerH;
    }

    $('html, body').animate({
      scrollTop: position
    }, speed, 'easeOutCubic');
    return false;
  });
});
$(window).on('load', function() {
  var url = $(location).attr('href');
  var headerH = $('header').outerHeight();
  if(url.indexOf("#") !== -1){
    var id = url.split("#");
    var $target = $('#' + id[id.length - 1]);
    if($target.length){
      if( $(window).width() > 700 ){
        var pos = $target.offset().top;
      }
      else{
        var pos = $target.offset().top - headerH;
      }
      $("html, body").animate({scrollTop:pos}, 0, 'easeOutCubic');
    }
  }
});